import { Component, Inject, Input, OnInit, Optional } from '@angular/core';

import { ModalWidgetComponentRef } from '../widget/modal.widget.component';
import {
    CMPS_WIDGET_MODAL_HANDLE,
    CMPS_WIDGET_OPTIONS,
} from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import {
    ScorecardListPopup,
    ScorecardListPopupItem,
} from './scorecard-list.widget.model';

@Component({
    selector: 'cmps-widget-scorecard-list',
    templateUrl: './scorecard-list.widget.component.html',
})
export class ScorecardListWidgetComponent implements OnInit {
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    data: ScorecardListPopup;
    @Input()
    options: any;

    constructor(
        @Optional()
        @Inject(CMPS_WIDGET_MODAL_HANDLE)
        private readonly _modalHandle: ModalWidgetComponentRef,
        private readonly _service: LegacyWidgetService,
        @Optional() @Inject(CMPS_WIDGET_OPTIONS) private readonly _options: any,
    ) {
        this.options = _options || this.options || {};
        this.options.startDate = this.options.startDate || [];
    }

    ngOnInit(): void {
        this.hasPendingData = true;
        this._service
            .scorecardListPopup(this.options.startDate)
            // eslint-disable-next-line no-return-assign
            .subscribe(
                (data) => (this.data = data),
                // eslint-disable-next-line n/handle-callback-err, no-return-assign
                (error) => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    showScorecard(item: ScorecardListPopupItem): void {
        if (this._modalHandle) {
            this._modalHandle.activeModal.close({ item });
        }
    }
}
